<ng-template #standardStrategy>
  <div class="dialog-container" style="padding: 25px;">
    <div class="dialog-heading">
      <h2 mat-dialog-title>
        {{'questions.typeOfQuestAiDriven.questionChoice.criteria.title' | translate}}
      </h2>
      <span class="spacer"></span>
      <div class="btn-close">
        <button (click)="closeDialog()" mat-icon-button aria-label="Close Dialog">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <mat-dialog-content class="mat-typography">
      <form [formGroup]="addStrategyForm" novalidate>
        <div class="form-wrapper">
          <div class="input-wrapper">
            <div class="input-label">
              <label>{{'questions.typeOfQuestAiDriven.questionChoice.criteria.labelName' | translate}}
              </label><span class="required">*</span>
            </div>
            <div class="input-field">
              <input type="text" rows="1" class="form-control" formControlName="StrategyName">
              <div
                *ngIf="addStrategyForm.get('StrategyName').invalid && (addStrategyForm.get('StrategyName').dirty || addStrategyForm.get('StrategyName').touched)"
                class="alert alert-danger">
                <div *ngIf="addStrategyForm.get('StrategyName').errors?.required">
                  {{'questions.typeOfQuestAiDriven.questionChoice.criteria.nameError1' | translate}}
                </div>
                <div *ngIf="addStrategyForm.get('StrategyName').errors?.minlength">
                  {{'questions.typeOfQuestAiDriven.questionChoice.criteria.nameError2' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper">
            <div class="input-label">
              <label>{{'questions.typeOfQuestAiDriven.questionChoice.criteria.labelValue' | translate}}
              </label><span class="required">*</span>
            </div>
            <div class="input-field">
              <input type="text" rows="1" class="form-control" formControlName="value">
              <div *ngIf="addStrategyForm.get('value').invalid && (addStrategyForm.get('value').dirty || addStrategyForm.get('value').touched)"
                class="alert alert-danger">
                <div *ngIf="addStrategyForm.get('value').errors?.required">
                  {{'questions.typeOfQuestAiDriven.questionChoice.criteria.valueError1' | translate}}
                </div>
                <div *ngIf="addStrategyForm.get('value').errors?.minlength">
                  {{'questions.typeOfQuestAiDriven.questionChoice.criteria.valueError2' | translate}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-flat-button color="" (click)='saveStrategy()' mat-raised-button class="btn-primary"
        [disabled]='addStrategyForm.invalid'>
        {{'questions.typeOfQuestAiDriven.questionChoice.criteria.btnAdd' | translate}}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
